import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";

export default function RolesManagementPage() {
    const location = useLocation();
    const successMessage = location.state?.successMessage;
    const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [roles, setRoles] = useState([]);
    const [filteredRoles, setFilteredRoles] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterType, setFilterType] = useState("all");


    const handleToggleActive = async (roleId, isActive) => {
        console.log(roleId);
        console.log(isActive);
        if (window.confirm(isActive ? "هل أنت متأكد من الغاء تفعيل الدور" : "هل أنت متأكد من تفعيل الدور")) {
            try {
                const res = await backEnd_request.patch("/admin/Roles/" + roleId + "/toggle-active", !isActive);
                fetchRoles();
            } catch (error) {
                console.log(error.response?.data || error);
            }
        }
    };

    //  جلب الأدوار من السيرفر
    const fetchRoles = async () => {
        try {
            const res = await backEnd_request.get("/admin/Roles");
            setRoles(res.data.roles || res.data);
            setFilteredRoles(res.data.roles || res.data);
        } catch (error) {
            console.log(error.response?.data || error);
        }
    };

    useEffect(() => {
        fetchRoles();
    }, []);

    // 🔍 البحث والتصفية
    const handleSearch = (term, type) => {
        setSearchTerm(term);
        setFilterType(type);

        let filtered = roles.filter((role) => {
            if (!term.trim()) return true;
            switch (type) {
                case "name":
                    return role.name?.toLowerCase().includes(term.toLowerCase());
                case "displayName":
                    return role.displayName?.toLowerCase().includes(term.toLowerCase());
                case "description":
                    return role.description?.toLowerCase().includes(term.toLowerCase());
                default:
                    return (
                        role.name?.toLowerCase().includes(term.toLowerCase()) ||
                        role.displayName?.toLowerCase().includes(term.toLowerCase()) ||
                        role.description?.toLowerCase().includes(term.toLowerCase())
                    );
            }
        });

        setFilteredRoles(filtered);
    };

    // 🗑️ حذف دور
    const handleDelete = async (roleId) => {
        if (window.confirm("هل أنت متأكد من حذف هذا الدور؟")) {
            try {
                await backEnd_request.delete(`/admin/Roles/${roleId}`);
                fetchRoles();
                setDeleteSuccessMessage("تم حذف الدور بنجاح ✅");
                setTimeout(() => setDeleteSuccessMessage(""), 3000);
            } catch (error) {
                console.log(error.response?.data || error);
            }
        }
    };

    return (
        <div className="container py-5">
            {/* العنوان + زر الإضافة */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="fw-bold text-primary">إدارة الأدوار</h3>
                <button
                    className="btn btn-success"
                    onClick={() => navigate("/admin/roles-management/create")}
                >
                    <i className="bi bi-plus-circle"></i> إضافة دور
                </button>
            </div>

            {/* رسائل النجاح */}
            {successMessage && (
                <div className="alert alert-success text-center fw-bold">
                    {successMessage}
                </div>
            )}
            {deleteSuccessMessage && (
                <div className="alert alert-success text-center fw-bold">
                    {deleteSuccessMessage}
                </div>
            )}

            {/* أدوات البحث */}
            <div className="card shadow-sm mb-4 p-3">
                <div className="row g-3 align-items-center">
                    <div className="col-md-4">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="اكتب هنا للبحث..."
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value, filterType)}
                        />
                    </div>
                    <div className="col-md-3">
                        <select
                            className="form-select"
                            value={filterType}
                            onChange={(e) => handleSearch(searchTerm, e.target.value)}
                        >
                            <option value="all">كل الحقول</option>
                            <option value="name">الاسم</option>
                            <option value="displayName">الاسم الظاهر</option>
                            <option value="description">الوصف</option>
                        </select>
                    </div>
                    <div className="col-md-2">
                        <button
                            className="btn btn-outline-secondary w-100"
                            onClick={() => {
                                setSearchTerm("");
                                setFilteredRoles(roles);
                            }}
                        >
                            إعادة تعيين
                        </button>
                    </div>
                </div>
            </div>

            {/* الجدول */}
            <div className="table-responsive shadow-sm">
                <table className="table table-hover align-middle text-center">
                    <thead className="table-primary">
                        <tr>
                            <th>الاسم</th>
                            <th>الاسم الظاهر</th>
                            <th>الوصف</th>
                            <th>نوع المستخدم</th>
                            <th>نشط؟</th>
                            <th>نظامي؟</th>
                            <th>عدد الصلاحيات</th>
                            <th>إجراءات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredRoles.length > 0 ? (
                            filteredRoles.map((role) => (
                                <tr key={role.roleId}>
                                    <td>{role.name}</td>
                                    <td>{role.displayName}</td>
                                    <td>{role.description || "-"}</td>
                                    <td>{role.userTypeName || "-"}</td>
                                    <td>
                                        <span
                                            className={`badge ${role.isActive ? "bg-success" : "bg-danger"
                                                }`}
                                        >
                                            {role.isActive ? "نشط" : "غير نشط"}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            className={`badge ${role.isSystemRole
                                                ? "bg-warning text-dark"
                                                : "bg-info text-dark"
                                                }`}
                                        >
                                            {role.isSystemRole ? "نظامي" : "عادي"}
                                        </span>
                                    </td>
                                    <td>{role.permissions?.length || 0}</td>
                                    <td>
                                        <button
                                            className="btn btn-sm btn-outline-primary me-2"
                                            onClick={() =>
                                                navigate(`/admin/roles-management/edit/${role.roleId}`)
                                            }
                                        >
                                            <i className="bi bi-pencil"></i>
                                        </button>
                                        <button
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => handleDelete(role.roleId)}
                                        >
                                            <i className="bi bi-trash"></i>
                                        </button>
                                        <button
                                            className={`btn btn-sm ${role.isActive
                                                ? "btn-outline-warning"
                                                : "btn-outline-success"
                                                }`}
                                            onClick={() =>
                                                handleToggleActive(
                                                    role.roleId,
                                                    role.isActive
                                                )
                                            }
                                        >
                                            {role.isActive ? (
                                                <i className="bi bi-slash-circle"></i>
                                            ) : (
                                                <i className="bi bi-check-circle"></i>
                                            )}
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-muted py-4">
                                    لا توجد بيانات لعرضها
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
